// extracted by mini-css-extract-plugin
module.exports = {"root":"SetupDeals_root__eqKxT","clearButton":"SetupDeals_clearButton__aH5S1"};